export const HMAC_SHA_256 = 'SHA_256';
